/**
 * Warehouse User Admin
 */

// React
import React, { useEffect, useContext, useState } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux

import UsersRepository from 'client-sdk/src/Repository/users-repository';
import WarehousesRepository from 'client-sdk/src/Repository/warehouses-repository';
import handleError from '../../utils/handleError';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import theme from '../../theme';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiPhoneOutline,
  mdiCounter,
  mdiCalendar,
  mdiCalendarClock,
  mdiAccountPlusOutline,
  mdiMapMarkerOutline,
  mdiWarehouse,
  mdiClose,
  mdiAccountArrowLeftOutline,
} from '@mdi/js';

// Components
import ListUsers from './list';
import Can from '../../components/Can';
import Modal from '../../components/Modal';
import Add from './componets/add';
import OrderList from './orderList'
import PrintModal from './componets/printModal/PrintModal';

// Rules

// Helper
import { formaterPhoneNumber } from '../../utils/helpers';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import handleNotfication from '../../utils/handleNotification';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);
export function AdminUser(props) {
  const [openAdd, setOpenAdd] = useState(false as boolean);
  const [modal, setModal] = useState("")
  const authContext = useContext(AuthContext);
  const { warehouseId } = authContext.user;
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 40,
  } as any);

  const handleClose = () => {
    setOpenAdd(false);
  };
  const classes = useStyles();

  const [warehouse, setWarehouse] = useState({});
  const [users, setUsers] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPrintDiolog, setOpenPrintDiolog] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const createUser = async (body: any, callback: () => void) => {
    const payload = {
      body,

      pagination: {
        ...filtersValues,
        'role.equals': 'WAREHOUSE_OPERATOR',
        'warehousesId.specified': false,
      },
    };
    try {
      setLoading(true);
      const { response, callback } = await UsersRepository.createUser({ payload });
      callback && callback();
      handleClose();
      handleNotfication('کاربر با موفقیت اضافه شد', 'success');
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getUser = async () => {
    try {
      setLoading(true);
      const response = await warehouseRepository.getWarehouseOperatorsById({
        payload: {
          id: { equals: warehouseId },
          role: { equals: 'WAREHOUSE_OPERATOR' },
          status: { equals: 'ACTIVE' },
          with: 'orders-count',
          page: 0,
          size: 20,
        },
      });
      setUsers(response.data.content);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getOperatorOrders = async (operatorId: string) => {
    try {
      const response = await ordersRepository.getAllOrders({
        payload: {
          "operatorId.equals": operatorId,
          status: { equals: 'ASSIGNED' },
          page: 0,
          size: 200,
        },
      });
      setOperatorData(response.data);
    } catch (error) {
      handleError(error.response);
    }
  };

  useEffect(() => {
    // @ts-ignore
    getWarehouses();
    getUser();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getWarehousesWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await WarehousesRepository.getWarehouseWithId({ payload });
      setWarehouse(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getWarehouses = async () => {
    const id = authContext.user.warehouseId;
    await getWarehousesWithId(id);
  };

  const openOperatorOrder = (id: string) => {
    getOperatorOrders(id)
    setModal('OPERATOR_ORDERS')
  }

  const handleCloseOperatorOrders = () => {
    setModal('')
    setOperatorData([])
  }
  const openPrintModal = (item: any) => {
    setSelectedUser(() => ({
      user: item.id,
      counts: item.ordersCount,
      name: item.name
    }))
    setOpenPrintDiolog(true)
  }
  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات 
        ${warehouse.name}
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{warehouse.id}</span>
      </div>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام انبار:  `}
              </span>

              <span>{warehouse.name}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه انبار:  `}
              </span>
              <span>{warehouse.id}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {` شماره تلفن:  `}
              </span>
              <span>{formaterPhoneNumber(warehouse.phoneNumber)}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {`ظرفیت:  `}
              </span>
              <span>{warehouse.capacity}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {` روزهای فعالیت: `}
              </span>
              <span>{warehouse.workDays}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {` ساعت فعالیت: `}
              </span>
              <span>{warehouse.workTimes}</span>
            </div>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس انبار: `}
              </span>
              <span>{warehouse.address}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid container item xs={12} spacing={2} direction="row-reverse">
          <Can
            role={authContext.user.role}
            perform="user:createNewUser"
            yes={() => (
              <Button
                onClick={() => setOpenAdd(true)}
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiAccountArrowLeftOutline} size={1} />}
              >
                {`ایجاد اپراتور`}
              </Button>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            users && <ListUsers data={users} openOrderModal={openOperatorOrder} openPrintModal={openPrintModal} />
          )}
        </Grid>
      </Grid>
      <Modal
        onClose={() => setOpenPrintDiolog(false)}
        open={openPrintDiolog}
        title={
          <div >
            {`    چه تعداد پیک لیست برای   
           ${selectedUser.name}
           پرینت شود؟`}
          </div>
        }
        content={
          <PrintModal selectedUser={selectedUser} />
        }
      />
      <Modal
        onClose={handleCloseOperatorOrders}
        open={modal === 'OPERATOR_ORDERS'}
        maxWidth="lg"
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiAccountPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <>{operatorData?.length > 0 ? (<OrderList data={operatorData} />) : (<div className={classes.loading}>
            <CircularProgress />
          </div>)}</>
        }
        actions={
          <Button variant='contained' onClick={handleCloseOperatorOrders}>بستن</Button>
        }
      />
      <Modal
        onClose={handleCloseOperatorOrders}
        open={modal === 'OPERATOR_ORDERS'}
        maxWidth="lg"
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiAccountPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <>{operatorData?.length > 0 ? (<OrderList data={operatorData} />) : (<div className={classes.loading}>
            <CircularProgress />
          </div>)}</>
        }
        actions={
          <Button variant='contained' onClick={handleCloseOperatorOrders}>بستن</Button>
        }
      />
    </div>
  );
}

export default AdminUser;
